import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import LogoMark from "@/components/LogoMark";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/5 bg-noir">
    <div className="mx-auto max-w-7xl px-6 py-20 sm:px-10">
      <div className="grid gap-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <LogoMark size={42} />
            <div className="leading-none">
              <p className="font-serif text-xl tracking-[0.22em] text-ivoire">RÉMANENCE</p>
              <p className="mt-1.5 text-[9px] tracking-[0.5em] text-champagne">STUDIO</p>
            </div>
          </div>
          <p className="mt-8 max-w-sm font-serif text-2xl font-light italic leading-snug text-ivoire/70">
            Créer ce qui demeure.
          </p>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-pierre">
            Studio de communication, branding et création de sites web.
            Des identités sobres, élégantes et pensées pour traverser le temps.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="overline-label">Navigation</p>
          <nav className="mt-6 flex flex-col gap-3" aria-label="Navigation pied de page">
            {[
              { to: "/", label: "Accueil" },
              { to: "/le-studio", label: "Le Studio" },
              { to: "/services", label: "Nos Services" },
              { to: "/portfolio", label: "Portfolio" },
              { to: "/contact", label: "Contact" },
            ].map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="w-fit text-sm text-ivoire/60 transition-colors duration-300 hover:text-champagne"
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="md:col-span-4">
          <p className="overline-label">Contact</p>
          <div className="mt-6 flex flex-col gap-4 text-sm text-ivoire/70">
            <p className="font-medium text-ivoire">Ronald Bellaiche</p>
            <a
              href="tel:+33660984025"
              data-testid="footer-phone-link"
              className="flex w-fit items-center gap-3 transition-colors duration-300 hover:text-champagne"
            >
              <Phone size={14} strokeWidth={1} className="text-champagne" />
              06 60 98 40 25
            </a>
            <a
              href="mailto:ronaldbellaiche1@gmail.com"
              data-testid="footer-email-link"
              className="flex w-fit items-center gap-3 transition-colors duration-300 hover:text-champagne"
            >
              <Mail size={14} strokeWidth={1} className="text-champagne" />
              ronaldbellaiche1@gmail.com
            </a>
            <p className="flex items-center gap-3">
              <MapPin size={14} strokeWidth={1} className="text-champagne" />
              Monteils, Gard — France
            </p>
          </div>
        </div>
      </div>

      <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/5 pt-8 sm:flex-row sm:items-center">
        <p className="text-xs tracking-wide text-pierre">
          © 2026 Rémanence Studio. Tous droits réservés.
        </p>
        <p className="text-xs uppercase tracking-[0.3em] text-pierre">
          Identité · Print · Digital · Web
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
